import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/nitido/:section?'),
    name: 'nitido_workspace',
    component: () => import('./Workspace.vue'),
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
  },
];
